<template>
  <div class="common">
    <!-- content -->
    <div class="com_content">
      <!-- menuLeftList -->
      <div class="menuLeftList">
        <img :src="oneMenuInfo ? ipPage + oneMenuInfo.menuImgUrl : ''" alt="" width="195" height="103" />
        <ul class="menuLeftList_menu">
          <li v-for="(menuLists) in twoMenuList" :key="menuLists.menuEnName" :class="{'twoMenuListActive':active==menuLists.uiMenuId}" @click="topath(menuLists)">
            {{ languageSet === "zh" ? menuLists.menuName : menuLists.menuEnName }}
          </li>
        </ul>
      </div>
      <!-- rightcontent -->
      <div class="rightContent">
        <div class="com_content_header" v-if="oneMenuInfo">
          <div class="com_content_header_title">
            {{ languageSet === "zh" ?oneMenuInfo.menuName:oneMenuInfo.menuEnName}}
          </div>
          <div class="com_content_header_addr">
            {{ languageSet === "zh" ?oneMenuInfo.menuName:oneMenuInfo.menuEnName }}>{{languageSet === "zh" ?activeName[0]:activeName[1]}}
          </div>
        </div>
        <img src="../assets/img/top_bar.png" alt="" height="6" width="100%" />
        <div class="main_content">
          <router-view />
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {
  getOneMenuInfo,//获取一级菜单信息
  menuListApi,//获取2级菜单
} from '../assets/js/api';
export default {
  data () {
    return {
      id: null,
      oneMenuInfo: null,
      twoMenuList: null,
      ipPage: sessionStorage.getItem("ips"),
      active: '',
      activeName: '',
      languageSet: localStorage.getItem("languageSet") || "zh",
    }
  },
  mounted () {
    this.getOneMenuInfoFun(this.$route.params.id);
    this.getmenuListApiFun(this.$route.params.id);
    window.addEventListener("setItem", this.setlanguageSetFun);
  },
  watch: {
    '$route' (to, from) {
      this.getOneMenuInfoFun(to.params.id);
      this.getmenuListApiFun(to.params.id);
    }
  },
  beforeDestroy () {
    window.removeEventListener("setItem", this.setlanguageSetFun);
  },
  methods: {
    setlanguageSetFun (e) {
      this.languageSet = e.newValue;
    },
    selectModule (item) {
      let detail_obj = JSON.parse(sessionStorage.getItem('detail_obj'));
      if (detail_obj && detail_obj.path && detail_obj.id) {
        this.$router.push({ path: `/common/${this.$route.params.id}/${detail_obj.path}` });
      } else {
        this.$router.push({ path: `/common/${this.$route.params.id}/${item}` });
      }

    },
    topath (item) {
      console.log(item);
      if (item.menuName === '温泉馆网上展厅') {
         window.open('http://106.15.207.28:88/fzwqg_vr/')
         return false;
      }
      if (item.menuName === '名城馆网上展厅') {
         window.open('http://106.15.207.28:88/fzmcg_vr/')
         return false;
      }
      this.active = item.uiMenuId;
      this.activeName = [item.menuName, item.menuEnName];
      sessionStorage.setItem('ActiveObj', JSON.stringify({ path: item.modulesType || 'error', active: item.uiMenuId, activeName: [item.menuName, item.menuEnName] }))
      this.$store.commit({ type: 'SECOND_ID', second_id: item.uiMenuId })
      sessionStorage.removeItem('detail_obj')
      this.selectModule(item.modulesType || 'error');
    },
    async getOneMenuInfoFun (id) {
      let { data } = await getOneMenuInfo(id);
      this.oneMenuInfo = data;
    },
    async getmenuListApiFun (id) {
      let { rows } = await menuListApi({ parentId: id });
      this.twoMenuList = rows;
      let active_obj = JSON.parse(sessionStorage.getItem('ActiveObj'))
      if (active_obj && active_obj.active && active_obj.activeName && active_obj.path) {
        this.active = active_obj.active;
        this.activeName = active_obj.activeName;
        this.$store.commit({ type: 'SECOND_ID', second_id: active_obj.active })
        this.selectModule(active_obj.path || 'error');
      } else {
        this.active = rows[0].uiMenuId;
        this.activeName = [rows[0].menuName, rows[0].menuEnName];
        sessionStorage.setItem('ActiveObj', JSON.stringify({ path: rows[0].modulesType || 'error', active: rows[0].uiMenuId, activeName: [rows[0].menuName, rows[0].menuEnName] }))
        this.$store.commit({ type: 'SECOND_ID', second_id: rows[0].uiMenuId })
        this.selectModule(rows[0].modulesType || 'error');
      }

    }
  }
}
</script>
<style lang="scss">
@import "../assets/css/com.scss";
.twoMenuListActive {
  color: #af9689 !important;
  background: url("../assets/img/active_menu.png") no-repeat !important;
  width: 146px !important;
  height: 39px !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/common.vue